import { render, staticRenderFns } from "./constructionProject.vue?vue&type=template&id=33e8b36a&scoped=true"
import script from "./constructionProject.vue?vue&type=script&lang=js"
export * from "./constructionProject.vue?vue&type=script&lang=js"
import style0 from "./constructionProject.vue?vue&type=style&index=0&id=33e8b36a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8b36a",
  null
  
)

export default component.exports